import ReactDOM from 'react-dom';
import Audio from './index';
import { AudioProps } from './types';

export default function showVideo(src?: string, otherParams?: AudioProps) {
  const div = document.createElement('div');
  document.body.appendChild(div);
  function handleClose() {
    ReactDOM.unmountComponentAtNode(div);
    if (div.parentNode) {
      div.parentNode.removeChild(div);
    }
    otherParams?.onClose?.()
  };
  const render = () => {
    ReactDOM.render(<Audio weId={`liveox`}
      controls
      src={src}
      {...otherParams}
      dialogProps={{
        visible: true
      }}
      isDialog
      onClose={handleClose}
    />, div);
  };
  render();
}
